import {
  createRouter,
  createWebHistory,
  createWebHashHistory
} from 'vue-router'
import Cookies from 'js-cookie'
import Root from '@/views/root/index.vue'
import Home from '@/views/home/index.vue'
import Product from '@/views/product/index.vue'
import Example from '@/views/example/index.vue'
import Price from '@/views/price/index.vue'
import Serve from '@/views/serve/index.vue'
import Resource from '@/views/resource/index.vue'
import CompanyProfile from '@/views/resource/companyProfile/index.vue'

const routes = [{
  path: '/',
  name: 'root',
  component: Root,
  redirect: '/home',
  children: [
    {
      path: '/home',
      name: 'home',
      component: Home,
    },
    {
      path: '/product',
      name: 'product',
      component: Product,
    },
    {
      path: '/news',
      name: 'news',
      component: Example,
    },
    {
      path: '/partner',
      name: 'partner',
      component: Price,
    },
    {
      path: '/contact',
      name: 'contact',
      component: Serve,
    },
    {
      path: '/about',
      name: 'about',
      component: Resource,

    },
  ]
},

]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  },

})
router.afterEach((to, from) => {
  Cookies.remove('token');
});

export default router
